import type { KanbanTaskCardBodyProps } from './kanban-task-card-body.types.ts';
import styles from './kanban-task-card-body.module.scss';

export function KanbanTaskCardBody({ children }: KanbanTaskCardBodyProps) {
  return <div className={styles.body}>{children}</div>;
}
